var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"wrapper"},[_c('UiTabs',{attrs:{"tag":"div","tabs":_vm.tabs},on:{"tab-click":_vm.handleTabClick}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }